import React, { Fragment } from "react";
import { ChangeEvent } from "react";
import { Prompt, RouteComponentProps } from "react-router-dom";

import { apiGet, apiPatch, apiPost, V1 } from "../../Api";
import withTitle from "../withTitle";

import { filterStateCode, formatZipCode } from "../../Utilities";
import ValidateInput from "../ValidateInput";

import "../../blocks.css";
// import "../../icomoon.css";
// import "../../indicator.css";
// import "../../list.css";
import "../../spinner.css";
// import "../../table.css";
import "../../user.css";
import "../viewer.css";
import ViewToolbar from "../ViewToolbar";
import OverflowMenuItem from "../OverflowMenuItem";
import ToolbarMenuItem from "../ToolbarMenuItem";
import DeletionConfirmationDialog from "../DeletionConfirmationDialog";
import ExpandList, { ExpandListEvent } from "../ExpandList";

interface ILocationDetailsState {
    error?: string;
    isLoading: boolean;
    isDeleteDialogOpen: boolean;
    location?: any;

    name: string;
    shortName: string;
    type: string;

    street: string;
    city: string;
    state: string;
    zip: string;

    color: string;
    geofences: any[];

    geoName: string;
    geoUpperRight: string;
    geoLowerLeft: string;

    isAddingGeo: boolean;

    isSubmitting: boolean;
    submitError?: string;
    hasChanged: boolean;

    [name: string]: any;
}


class LocationDetailsView extends React.Component<RouteComponentProps<any>, ILocationDetailsState> {
    private inputs: ValidateInput[];
    private inputsGeo: ValidateInput[];

    constructor(props: Readonly<RouteComponentProps<any>>) {
        super(props);

        this.state = {
            isLoading: true,
            isDeleteDialogOpen: false,

            name: "",
            shortName: "",
            type: "",

            city: "",
            state: "",
            street: "",
            zip: "",

            color: "",
            geofences: [],

            geoName: "",
            geoUpperRight: "",
            geoLowerLeft: "",

            isAddingGeo: false,

            hasChanged: false,
            isSubmitting: false,
        };

        this.submitChanges = this.submitChanges.bind(this);
        this.cancelChanges = this.cancelChanges.bind(this);
        this.handleInputChanged = this.handleInputChanged.bind(this);
        this.handleRef = this.handleRef.bind(this);
        this.toggleDeleteDialog = this.toggleDeleteDialog.bind(this);
        this.handleDeleteConfirm = this.handleDeleteConfirm.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.addGeofence = this.addGeofence.bind(this);
        this.cancelGeofence = this.cancelGeofence.bind(this);
        this.deleteGeofence = this.deleteGeofence.bind(this);

        this.inputs = [];
        this.inputsGeo = [];
    }

    public async componentDidMount() {
        const locationId = (this.props.match && this.props.match.params.id);

        try {
            if (locationId) {
                // Load existing location
                const location = await apiGet<any>(`locations/${locationId}`);

                this.setState({
                    isLoading: false,
                    location,

                    city: location.address.city,
                    state: location.address.state,
                    street: location.address.street,
                    zip: location.address.zip,

                    name: location.name,
                    shortName: location.shortName,
                    type: location.type,

                    color: location.color,
                    geofences: location.geofences,
                });
            }
            else {
                this.setState({
                    isLoading: false
                });
            }
        }
        catch (e) {
            this.setState({
                error: e.message,
                isLoading: false
            });
        }
    }

    public render() {
        if (this.state.isLoading) {
            return (
                <div className="viewer-root">
                    <div className="spinner-center lds-dual-ring-big" />
                </div>
            );
        }

        if (this.state.error) {
            return (
                <div className="viewer-root">
                    <span className="error-text">{this.state.error}</span>
                </div>
            );
        }

        return (
            <div className="viewer-root with-actionbar input-form">
                <Prompt when={this.state.hasChanged} message="Your changes will not be saved if you continue." />
                <ViewToolbar>
                    <OverflowMenuItem>
                        <ToolbarMenuItem right="location:delete">
                            <button type="button" className="button text-with-icon" onClick={this.toggleDeleteDialog}><i className="icon-trash" /><span>Delete location...</span></button>
                        </ToolbarMenuItem>
                    </OverflowMenuItem>
                </ViewToolbar>
                {this.state.isDeleteDialogOpen
                    ? <DeletionConfirmationDialog isOpen={this.state.isDeleteDialogOpen} description={`Are you sure you want to delete location ${this.state.location.name}?`} onRequestClose={this.toggleDeleteDialog} onConfirm={this.handleDeleteConfirm} onSuccess={this.handleDeleteSuccess} />
                    : null}
                <div className="column-root">
                    <section className="info-block">
                        <header>
                            <h3>Basic Information</h3>
                        </header>
                        <section>
                            <div className="input-form-group">
                                <label htmlFor="frm-loc-name">Name</label>
                                <ValidateInput type="text" id="frm-loc-name" ref={this.handleRef} className="input-light" name="name" value={this.state.name} onChange={this.handleInputChanged} placeholder="Name" autoComplete="off_please_chrome" isRequired={true} />
                            </div>
                        </section>
                        <section>
                            <div className="input-form-group">
                                <label htmlFor="frm-loc-shortname">Short Name</label>
                                <ValidateInput type="text" id="frm-loc-shortname" ref={this.handleRef} className="input-light" name="shortName" value={this.state.shortName} onChange={this.handleInputChanged} placeholder="Nickname" autoComplete="off_please_chrome" isRequired={false} />
                            </div>
                            <div className="input-form-group">
                                <label htmlFor="frm-loc-type">Type</label>
                                <ValidateInput type="select" id="frm-loc-type" ref={this.handleRef} className="input-light" name="type" value={this.state.type} onChange={this.handleInputChanged} placeholder="Type" autoComplete="off_please_chrome" isRequired={true}>
                                    <option value="office">Office</option>
                                    <option value="surgery">Surgery Center</option>
                                </ValidateInput>
                            </div>
                        </section>
                        <section>
                            <div className="input-form-group">
                                <label htmlFor="frm-color">Color</label>
                                <ValidateInput type="select" id="frm-color" ref={this.handleRef} className="input-light" name="color" value={this.state.color} onChange={this.handleInputChanged} placeholder="Type" autoComplete="off_please_chrome" isRequired={false}>
                                    <option value="">Default</option>
                                    <option value="green">Green</option>
                                    <option value="red">Red</option>
                                    <option value="yellow">Yellow</option>
                                    <option value="blue">Blue</option>
                                    <option value="orange">Orange</option>
                                    <option value="purple">Purple</option>
                                    <option value="cyan">Cyan</option>
                                    <option value="magenta">Magenta</option>
                                    <option value="lime">Lime</option>
                                    <option value="pink">Pink</option>
                                    <option value="teal">Teal</option>
                                    <option value="lavender">Lavender</option>
                                    <option value="brown">Brown</option>
                                    <option value="beige">Beige</option>
                                    <option value="maroon">Maroon</option>
                                    <option value="mint">Mint</option>
                                    <option value="olive">Olive</option>
                                    <option value="apricot">Apricot</option>
                                    <option value="navy">Navy</option>
                                    <option value="gray">Gray</option>
                                    <option value="white">White</option>
                                    <option value="black">Black</option>
                                </ValidateInput>
                            </div>
                            <div className="input-form-group" />
                        </section>
                    </section>
                    <section className="info-block">
                        <header>
                            <h3>Address</h3>
                        </header>
                        <section>
                            <div className="input-form-group">
                                <label htmlFor="frm-loc-addr-street">Address line 1</label>
                                <ValidateInput type="text" id="frm-loc-addr-street" ref={this.handleRef} className="input-light" name="street" value={this.state.street} onChange={this.handleInputChanged} placeholder="Street Address" autoComplete="off_please_chrome" isRequired={true} />
                            </div>
                        </section>
                        <section>
                            <div className="input-form-group">
                                <label htmlFor="frm-loc-addr-city">City</label>
                                <ValidateInput type="text" id="frm-loc-addr-city" ref={this.handleRef} className="input-light" name="city" value={this.state.city} onChange={this.handleInputChanged} placeholder="City" autoComplete="off_please_chrome" isRequired={true} />
                            </div>
                        </section>
                        <section className="always-row">
                            <div className="input-form-group">
                                <label htmlFor="frm-loc-addr-state">State</label>
                                <ValidateInput type="text" id="frm-loc-addr-state" ref={this.handleRef} className="input-light" name="state" value={this.state.state} onChange={this.handleInputChanged} placeholder="State (e.g. GA)" autoComplete="off_please_chrome" isRequired={true} filter={filterStateCode} />
                            </div>
                            <div className="input-form-group input-form-group-small">
                                <label htmlFor="frm-loc-addr-zip">ZIP code</label>
                                <ValidateInput type="text" id="frm-loc-addr-zip" ref={this.handleRef} className="input-light" name="zip" value={this.state.zip} onChange={this.handleInputChanged} placeholder="5 digit ZIP" autoComplete="off_please_chrome" isRequired={true} filter={formatZipCode} validator={this.validateZip} />
                            </div>
                        </section>
                    </section>
                </div>
                &nbsp;
                <div className="column-root">
                    <section className="info-block">
                        <header>
                            <h3>Geofences</h3>
                        </header>
                        <ExpandList items={this.state.geofences} itemIdField="id" itemRender={this.renderGeofence} disableAdd={true} onDelete={this.deleteGeofence} />
                        {this.state.isAddingGeo
                            ? <Fragment>
                                <section>
                                    <div className="input-form-group">
                                        <label htmlFor="frm-loc-geo-name">Name</label>
                                        <ValidateInput type="text" id="frm-loc-geo-name" className="input-light" name="geoName" value={this.state.geoName} autoFocus={true} onChange={this.handleInputChanged} placeholder="" autoComplete="off_please_chrome" isRequired={false} />
                                    </div>
                                </section>
                                <section>
                                    <div className="input-form-group">
                                        <label htmlFor="frm-loc-geo-ur">Upper-Right GPS Coord</label>
                                        <ValidateInput type="text" id="frm-loc-geo-ur" className="input-light" name="geoUpperRight" value={this.state.geoUpperRight} onChange={this.handleInputChanged} placeholder="" autoComplete="off_please_chrome" isRequired={true} />
                                    </div>
                                    <div className="input-form-group">
                                        <label htmlFor="frm-loc-geo-bl">Lower-Left GPS Coord</label>
                                        <ValidateInput type="text" id="frm-loc-geo-bl" className="input-light" name="geoLowerLeft" value={this.state.geoLowerLeft} onChange={this.handleInputChanged} placeholder="" autoComplete="off_please_chrome" isRequired={true} />
                                    </div>
                                </section>
                            </Fragment>
                            : null}
                        &nbsp;
                        <div className="action-panel-dialog">
                            {!this.state.isAddingGeo ? <button type="button" className="button smaller push-right icon-plus" title="Add new geofence..." onClick={() => this.setState({ isAddingGeo: true })}></button> : null}
                            {this.state.isAddingGeo ? <button type="button" className="button smaller push-right" onClick={this.addGeofence}>Save</button> : null}
                            {this.state.isAddingGeo ? <button type="button" className="button smaller" onClick={this.cancelGeofence}>Cancel</button> : null}
                        </div>
                    </section>
                    <section className="section-spacer" />
                </div>
                &nbsp;
                {this.state.submitError ? <span className="error-text">{this.state.submitError}</span> : ""}
                <div className="action-panel">
                    <button className="button blue btn-confirm push-right" disabled={this.state.isSubmitting} onClick={this.submitChanges}>Save</button>
                    <button className="button blue btn-cancel" disabled={this.state.isSubmitting} onClick={this.cancelChanges}>Cancel</button>
                </div>
            </div>
        );
    }

    private async submitChanges() {
        let allValid = true;
        for (const input of this.inputs) {
            allValid = input.validate() && allValid;
        }

        if (!allValid) {
            return;
        }

        try {
            if (this.state.location) {
                // Update existing location
                this.setState({
                    isSubmitting: true,
                    submitError: undefined
                });

                const update = {
                    address: {
                        city: this.state.city,
                        state: this.state.state,
                        street: this.state.street,
                        zip: this.state.zip
                    },
                    name: this.state.name,
                    shortName: this.state.shortName,
                    type: this.state.type,

                    color: this.state.color,
                    geofences: this.state.geofences,
                };

                await apiPatch(`locations/${this.state.location.id}`, update);

                this.setState({
                    hasChanged: false,
                    isSubmitting: false,
                });
            }
            else {
                // Create new location
                const creationInfo = {
                    address: {
                        city: this.state.city,
                        state: this.state.state,
                        street: this.state.street,
                        zip: this.state.zip
                    },
                    name: this.state.name,
                    shortName: this.state.shortName,
                    type: this.state.type,

                    color: this.state.color,
                    geofences: this.state.geofences,
                };

                this.setState({
                    isSubmitting: true,
                    submitError: undefined
                });

                await apiPost("locations", creationInfo);

                this.setState({
                    hasChanged: false,
                    isSubmitting: false,
                });
            }
            this.props.history.goBack();
        }
        catch (e) {
            this.setState({
                isSubmitting: false,
                submitError: e.message
            });
        }
    }

    private cancelChanges() {
        this.props.history.goBack();
    }

    private handleInputChanged(e: ChangeEvent<HTMLInputElement>) {
        const value = e.currentTarget.value;
        const name = e.currentTarget.name;

        this.setState({
            hasChanged: true,
            [name]: value
        })
    }

    private handleRef(input: ValidateInput) {
        this.inputs.push(input);
    }

    private validateZip(input: string) {
        return !!input.match(/^\d{5}$/);
    }

    private toggleDeleteDialog() {
        const isDeleteDialogOpen = this.state.isDeleteDialogOpen;
        this.setState({
            isDeleteDialogOpen: !isDeleteDialogOpen
        });
    }

    private handleDeleteConfirm() {
        return V1.delete<void>(`locations/${this.state.location.id}`);
    }

    private handleDeleteSuccess() {
        this.props.history.goBack();
    }

    private renderGeofence(item: any) {
        return <span>{item.name || "[default]"} <small>({item.area.upperRight.x}, {item.area.upperRight.y} &mdash; {item.area.lowerLeft.x}, {item.area.lowerLeft.y})</small></span>;
    }

    private addGeofence() {
        const { geoName, geoUpperRight, geoLowerLeft, geofences } = this.state;

        if (!geoUpperRight || !geoLowerLeft) {
            return;
        }

        const upperRight = geoUpperRight.split(",");
        const lowerLeft = geoLowerLeft.split(",");

        if (upperRight.length !== 2 || lowerLeft.length !== 2) {
            return;
        }

        const newFence = {
            id: Date.now().toString(),
            name: geoName || "",
            area: {
                upperRight: { x: upperRight[0].trim(), y: upperRight[1].trim() },
                lowerLeft: { x: lowerLeft[0].trim(), y: lowerLeft[1].trim() },
            }
        };

        geofences.push(newFence);

        this.setState({
            geofences,
            isAddingGeo: false
        });
    }

    private cancelGeofence() {
        this.setState({
            isAddingGeo: false,
            geoName: "",
            geoUpperRight: "",
            geoLowerLeft: ""
        });
    }

    private deleteGeofence(e: ExpandListEvent<any>) {
        const { geofences } = this.state;

        geofences.splice(e.index!, 1);

        this.setState({
            geofences
        });
    }
}

export default withTitle("UOG Location Details", LocationDetailsView);
